import React from "react";
import { Breadcrumb } from "react-bootstrap";
import WardVisitorForm from "../components/WardVisitorForm.jsx";
import styled from "styled-components";
import { useTranslation } from 'react-i18next';

const Styles = styled.div`
  .list-decimal {
    list-style-type: decimal;
  }

  .mandatory-note {
    color: red;
  }

  .content-top-header {
    color: #a6192e;
  }

  .breadcrumb-bg {
    background-color: #e9ecef;
  }
`;



const WardVisitor = () => {
  const { t } = useTranslation(); // LANGUAGE

  return (
    <Styles>
      <div className="row breadcrumb-bg animate__animated animate__fadeIn">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="https://www.ttsh.com.sg/Pages/default.aspx">
              <small>
                {/* Home */}
                {t('mainpage-btn.4')}
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/">
              <small>
                {/* Visitor Facilitation */}
                {t('mainpage-btn.5')}
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              <small>
                {/* Ward Visitor */}
                {t('mainpage-btn.1')}
              </small>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <div className="container">
        <br />
        <div className="content-top">
          <h3 className="content-top-header animate__animated animate__fadeInLeft animate__delay-500ms">
            {/* WARD VISITOR */}
            {t('mainpage-heading.2')}
          </h3>
          <p className="animate__animated animate__fadeInUp animate__delay-600ms">
            {/* Visiting hours and the number of visitors are restricted to ensure
            that our patients have adequate rest and to lower the risk of
            infection from visitors. Our visiting policy allows two (2) visitors
            per patient at any one time during visiting hours. */}
            {t('long-word.1')}
          </p>

          <ul className="list-unstyled animate__animated animate__fadeInUp animate__delay-700ms">
            <li>
              {/* This registration facilitates visitors’ entry to the wards on the
              day of visit. Visitors have to access the gantries at the
              respective lift lobbies and are required to abide by our visiting
              policy: */}
              {t('long-word.2')}
            </li>
            <ul>
              <li>
                {/* Only two (2) visitors per patient at any one time. */}
                {t('long-word.3')}
              </li>
              <li>
                {/* Daily visiting hours are between 12.00 noon to 2.00 pm, and 5.00
                pm to 8.30 pm. */}
                {t('long-word.4')}
              </li>
            </ul>
          </ul>
        </div>

        <hr className="animate__animated animate__bounceIn animate__delay-1s" />

        <div className="content-instructions animate__animated animate__fadeInUp animate__delay-700ms">
          <h5>
            {/* INSTRUCTIONS FOR REGISTRATION */}
            {t('mainpage-heading.6')}
          </h5>

          <ol className="list-decimal">
            <li>
              {/* Visitor’s registration is non-transferable. */}
              {t('long-word.6')}
            </li>
            <li>
              {/* Online registration is only applicable to Singaporeans, permanent
              residents and foreigners holding work permits or employment
              passes. Other foreign visitors are required to register at the
              Visitor Registration Counters at Level 1 Lift Lobbies. */}
              {t('long-word.7')}
            </li>
            <li>
              {/* Multiple visitors may register for the same patient. However, only two (2) visitors may enter at any one time. */}
              {t('long-word.8')}
            </li>
            <li>
              {/* Registration does not give visitors unlimited access to other ward levels. */}
              {t('long-word.9')}
            </li>
            <li>
              {/* Children below the age of 12 are not permitted to visit clinical areas. */}
              {t('long-word.10')}
            </li>
            <li>
              {/* Visitors are required to fill-in: */}
              {t('long-word.11')}
            </li>
            <ul>
              <li>
                {/* Visitor’s name, NRIC / FIN number and mobile phone number (for SMS notification service) */}
                {t('long-word.12')}
              </li>
              <li>
                {/* Patient’s full name (as in identity card) and Ward, Room and Bed Numbers. */}
                {t('long-word.13')}
              </li>
            </ul>
            <li>
              {/* Visitors may call our general enquiries line at 0000 0000 for assistance. */}
              {t('long-word.14')}
            </li>
          </ol>
        </div>

        <hr className="animate__animated animate__bounceIn animate__delay-1s" />

        <div className="content-form animate__animated animate__fadeInUp animate__delay-800ms">
          <h5>
            {/* REGISTRATION FORM */}
            {t('mainpage-heading.5')}
          </h5>
          <small className="mandatory-note">
            {/* * Mandatory  */}
            {t('short-word.6')}
          </small>

          {/* Ward Visitor form */}
          <WardVisitorForm />
        </div>
      </div>
    </Styles>
  );
};

export default WardVisitor;
